import React, { useState, useEffect, useCallback } from "react";
import { useSwipeable } from "react-swipeable";

const Modal = ({ image, onClose, onNext, onPrev }) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(true);

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
    setTimeout(() => onClose(), 180);
  }, [onClose]);

  const handleNext = useCallback(() => onNext(), [onNext]);
  const handlePrev = useCallback(() => onPrev(), [onPrev]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") closeModal();
      if (e.key === "ArrowRight") handleNext();
      if (e.key === "ArrowLeft") handlePrev();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [closeModal, handleNext, handlePrev]);

  const handlers = useSwipeable({
    onSwipedLeft: handleNext,
    onSwipedRight: handlePrev,
    trackMouse: true,
  });

  return (
    <div
      {...handlers}
      className={`modal ${showModal ? "show" : ""}`}
      onClick={closeModal} // klik poza "zawartość" zamyka
      role="dialog"
      aria-modal="true"
    >
      <div className="modal-content">
        <button
          className="close"
          onClick={(e) => {
            e.stopPropagation();
            closeModal();
          }}
          aria-label="Zamknij"
        >
          ×
        </button>

        {/* LEWA strefa */}
        <button
          className="navZone navLeft"
          onClick={(e) => {
            e.stopPropagation();
            handlePrev();
          }}
          aria-label="Poprzednie zdjęcie"
        >
          <span className="navArrow">‹</span>
        </button>

        {/* OBRAZ - TYLKO TU blokujemy zamykanie */}
        <img
          className="modal-image"
          src={image.src}
          alt={image.alt}
          onClick={(e) => e.stopPropagation()} // klik w zdjęcie NIE zamyka
        />

        {/* PRAWA strefa */}
        <button
          className="navZone navRight"
          onClick={(e) => {
            e.stopPropagation();
            handleNext();
          }}
          aria-label="Następne zdjęcie"
        >
          <span className="navArrow">›</span>
        </button>
      </div>
    </div>
  );
};

export default Modal;
